import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgX = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.3263 2.4043H21.6998L14.3297 10.8278L23 22.2903H16.2112L10.894 15.3383L4.80995 22.2903H1.43443L9.31743 13.2804L1 2.4043H7.96111L12.7674 8.75863L18.3263 2.4043ZM17.1423 20.2711H19.0116L6.94539 4.31743H4.93946L17.1423 20.2711Z",
		fill: "white"
	})
});
export default SvgX;
